import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
    query lunchRatesWithPagination($page: Int, $perPage: Int) {
        lunchRatesWithPagination(page: $page, first: $perPage){
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                price
                is_active
                status_text
            }
        }
    }
`

const ALL_ACTIVE = gql`
    query lunchRatesActive {
        lunchRatesActive {
            id
            name
            price
            is_active
            status_text
        }
    }
`

/**
 * Mutations
 */
const CHANGE_STATUS = gql`
    mutation updateLunchRate ($id: ID!, $status: Boolean) {
        updateLunchRate (id: $id, input: {
            is_active: $status
        }) {
            id
            is_active
            status_text
        }
    }
`

const SAVE = gql`
    mutation createLunchRate ($input: CreateLunchRateInput!) {
        createLunchRate (input: $input) {
            name
            price
            id
            is_active
        }
    }
`

const UPDATE = gql`
    mutation updateLunchRate ($id: ID!, $input: UpdateLunchRateInput!) {
        updateLunchRate (id: $id, input: $input) {
            name
            price
            id
            is_active
        }
    }
`

const DELETE = gql`
    mutation deleteLunchRate ($id: ID!) {
        deleteLunchRate(id: $id) { 
            id
        }
    }
`

export {
    GET_WITH_PAGINATION,
    ALL_ACTIVE,
    CHANGE_STATUS,
    SAVE,
    UPDATE,
    DELETE
}
